import { cn } from "@/lib/utils";

export function AllPhotosIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-4 text-white", className)}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 3.5A1.5 1.5 0 0 1 3.5 2H5a1.5 1.5 0 0 1 1.5 1.5V5A1.5 1.5 0 0 1 5 6.5H3.5A1.5 1.5 0 0 1 2 5zm7.5 0A1.5 1.5 0 0 1 11 2h1.5A1.5 1.5 0 0 1 14 3.5V5a1.5 1.5 0 0 1-1.5 1.5H11A1.5 1.5 0 0 1 9.5 5zM2 11a1.5 1.5 0 0 1 1.5-1.5H5A1.5 1.5 0 0 1 6.5 11v1.5A1.5 1.5 0 0 1 5 14H3.5A1.5 1.5 0 0 1 2 12.5zm7.5 0A1.5 1.5 0 0 1 11 9.5h1.5A1.5 1.5 0 0 1 14 11v1.5a1.5 1.5 0 0 1-1.5 1.5H11a1.5 1.5 0 0 1-1.5-1.5z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function NextIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4 w-[9px] text-ruby-red", className)}
      viewBox="0 0 9 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.39 12.933L5.564 7.63.39 2.327A1.385 1.385 0 01.39.4a1.305 1.305 0 011.88 0l6.12 6.273c.52.533.52 1.394 0 1.927l-6.12 6.274c-.52.533-1.36.533-1.88 0-.507-.534-.52-1.408 0-1.941z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PrevIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4 w-[9px] text-ruby-red", className)}
      viewBox="0 0 9 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.61 12.933L3.436 7.63 8.61 2.327c.52-.533.52-1.394 0-1.927a1.305 1.305 0 00-1.88 0L.61 6.673a1.385 1.385 0 000 1.927l6.12 6.274c.52.533 1.36.533 1.88 0 .507-.534.52-1.408 0-1.941z"
        fill="currentColor"
      />
    </svg>
  );
}
